import React, { useContext, useState } from 'react'
import CommonModal from '../../UiKits/Modals/common/modal'
import UploadImageContain from '../../BonusUi/ImageUpload'
import { Input, Label } from 'reactstrap'
import StudentContext from '../../../Helper/Students'
import { toast } from 'react-toastify'
import { firebaseFunction } from '../../../firebase/init'
import { changeStudentCourse, uploadImageToFirebase } from '../../../firebase/utils'
import courseContext from '../../../Helper/Courses'

const FeeRefund = ({ data, open, setOpen, module, updateStudents, courseStudents, setTotal }) => {
  const { students, setStudents } = useContext(StudentContext)
  const { activeCourse } = useContext(courseContext)
  const [files, setFiles] = useState([])
  const [amount, setAmount] = useState(0)
  const [loading, setLoading] = useState(false)


  const feeRefundHandler = async () => {
    const refundScreenhsot = files[0]
    const feeAmount = data.courses[data.courseIndex].feeScreenshots[module].feeAmount || 0
    if (!refundScreenhsot?.name) {
      toast.error("Please upload transaction slipt");
      return;
    } else if (!amount) {
      toast.error('Please enter refund amount')
      return
    } else if (+amount > feeAmount) {
      toast.error('Please enter a valid refund amount')
      return
    }
    try {
      setLoading(true);
      const reciptUrl = await uploadImageToFirebase(
        refundScreenhsot,
        "refundRecipt"
      );
      data.courses[data.courseIndex].feeScreenshots[
        module
      ].refundReceiptUrl = reciptUrl;
      data.courses[data.courseIndex].feeScreenshots[module].status =
        "refunded";
      data.courses[data.courseIndex].feeScreenshots[module].refundDate =
        new Date();
      data.courses[data.courseIndex].feeScreenshots[module].refundAmount =
        +amount;
      data.isRefund = true;
      console.log(data)
      let sendEmail = firebaseFunction.httpsCallable('sendEmail')

      setTotal()
      await changeStudentCourse(data.email, data.courses)
      await sendEmail({
        toEmail: data.email,
        subject: "EU Portal | Response to a fee refund.",
        name: data.fullName,
        courseName: activeCourse.name,
        feeStatus: "refund",
        courseType: activeCourse.type,
        courseModule: module == 0 ? 1 : 2,
        feeImage: reciptUrl,
      })
      updateFeeData()
      setOpen(false)

      toast.success("Fee refund sucessfully");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const updateFeeData = () => {
    const studentMainDataIndex = students.findIndex((student) => student.email === data.email)
    const studentsLocalDataIndex = courseStudents.findIndex((student) => student.email === data.email)
    setStudents(previousStudents => {
      const newStudent = [...previousStudents];
      students[studentMainDataIndex] = data;
      return newStudent;
    });
    updateStudents(previousStudents => {
      const newStudent = [...previousStudents];
      courseStudents[studentsLocalDataIndex] = data;
      return newStudent;
    });
  }


  return (
    <CommonModal
      isOpen={open}
      toggler={() => setOpen(false)}
      successText={'Save'}
      title='Fee Refund'
      showCloseBtn={false}
      success={() => feeRefundHandler()}
      loading={loading}
      size="md"
    >
      <div className='fee-refund'>

        <UploadImageContain
          files={files}
          setFiles={setFiles}
          heeading='Please upload refunded trasaction slipt'
        />
        <Label>Amount</Label>
        <Input
          type='number'
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder='Please enter fee refund amount'
        />
      </div>
    </CommonModal>
  )
}

export default FeeRefund